/*
================================================================================
| FILENAME: src/components/StatCard.jsx (Unified & Corrected)
| PURPOSE: To create a single, reusable StatCard component for the entire app
|          and to use a default export to prevent build errors.
|
| KEY CHANGES:
| 1.  Consolidated the different versions of StatCard into one.
| 2.  It now accepts optional `icon` and `color` props for flexibility.
| 3.  Switched to a `default export` to standardize its usage.
================================================================================
*/
import React from 'react';

const StatCard = ({ title, value, icon, color = 'text-white' }) => (
    <div className="card p-4 bg-slate-800/50 border-slate-700">
        <h4 className="text-center font-semibold text-main">{title}</h4>
        <p className={`text-4xl ${color} font-bold text-center mt-2 flex items-center justify-center gap-2`}>
            {icon} {value}
        </p>
    </div>
);

export default StatCard;